import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { SharedService } from '../../../layouts/shared-service';
// Services
import { FuelreqsService } from '../../../services/fuelreqs.service';
import { SelectedDateFilter } from 'src/app/shared/components/preset-date-filter/preset-date-filter.component';

@Component({
    selector: 'app-analytics-orders-over-time',
    styleUrls: ['./analytics-orders-over-time-chart.component.scss'],
    templateUrl: './analytics-orders-over-time-chart.component.html',
})
export class AnalyticsOrdersOverTimeChartComponent implements OnInit {
    public filterStartDate: Date;
    public filterEndDate: Date;
    // Public Members
    public chartName = 'orders-over-time-chart';
    public totalOrdersData: any[];
    public colorScheme = {
        domain: [
            '#a8385d',
            '#7aa3e5',
            '#a27ea8',
            '#aae3f5',
            '#adcded',
            '#a95963',
            '#8796c0',
            '#7ed3ed',
            '#50abcc',
            '#ad6886',
        ],
    };

    public selectedFilter: string = '1M';

    constructor(
        private fuelreqsService: FuelreqsService,
        private sharedService: SharedService,
        private ngxLoader: NgxUiLoaderService
    ) {
        this.filterStartDate = new Date(
            moment().add(-1, 'M').format('MM/DD/YYYY')
        );
        this.filterEndDate = new Date(moment().format('MM/DD/YYYY'));
    }

    ngOnInit() {
        this.refreshData();
    }

    public refreshData() {
        this.ngxLoader.startLoader(this.chartName);
        this.fuelreqsService
            .getOrders(
                this.sharedService.currentUser.fboId,
                this.filterStartDate,
                this.filterEndDate
            )
            .subscribe(
                (data: any) => {
                    this.totalOrdersData = data;
                },
                () => {},
                () => {
                    this.ngxLoader.stopLoader(this.chartName);
                }
            );
    }

    applyPresetDateFilter(filter: SelectedDateFilter) {
        this.filterStartDate = new Date(moment(filter.offsetDate).format('MM/DD/YYYY'));
        this.filterEndDate = new Date(moment(filter.limitDate).format('MM/DD/YYYY'));
        this.selectedFilter = filter.selectedFilter
        this.refreshData();
    }
    applyCustomDateFilter() {
        this.selectedFilter = null;
        this.refreshData();
    }
}
